const auxiliary = ( props ) => props.children;

export default auxiliary;


// WEBPACK FOOTER //
// ./src/hoc/Auxiliary/Auxiliary.js